import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import Search from './search';
import Submenu from './submenu';
import MenuMobile from './menu-mobile';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  height: 76px;
  background: #2D2D2C;
  position: relative;
  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 6;
  }
  @media (max-width: 789px) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 4;
  }
  .wrapper {
    justify-content: space-between;
    .items {
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: space-around;
      @media (min-width: 789px) {
        flex-grow: 1;
      }
    }
    a {
      transition: all 0.3s;
      color: #D2AE82;
      font: italic bold 20px 'Times New Roman';
      text-decoration: none;
      &:hover {
        color: #fff;
      }
      &.link {
        @media (max-width: 980px) {
          display: none;
        }
      }
    }
    @media (max-width: 630px) {
      .search {
        display: none;
      }
    }
    .hamburger-menu {
      display: none;
      border: 2px solid #D8B084;
      border-radius: 3px;
      height: 48px;
      padding: 0 20px;
      background: none;
      color: #D8B084;
      font: italic bold 20px 'Times New Roman';
      @media (max-width: 789px) {
        font-size: 16px;
        padding: 0 10px;
      }
      i {
        margin-left: 10px;
        display: inline-block;
        background: url(/images/hamb@2x.png) no-repeat center;
        background-size: contain;
        width: 24px;
        height: 15px;
        @media (max-width: 789px) {
          width: 20px;
          height: 20px;
        }
      }
      &.close {
        i {
          background: url(/images/close-menu.png) no-repeat center;
        }
      }
      @media (max-width: 980px) {
        display: flex;
        align-items: center;
      }
    }
  }
`
const Logo = styled.span`
  background: url(/images/logo-negativa.svg) no-repeat left;
  background-size: contain;
  height: 56px;
  width: 190px;
  display: inline-block;
  @media (max-width: 789px) {
    width: 140px;
  }
`

class Header extends Component {
  state = {
    fixed: false,
    menuStatus: false,
    url: '',
  }

  componentDidMount = () => {
    window.addEventListener("scroll", this.handleScroll);
    this.setState({url: this.props.match && this.props.match.url})
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  componentDidUpdate() {
    if (
      this.props.match && this.state.url !== this.props.match.url
    ) {
      this.setState({ menuStatus: false, url: this.props.match.url})
    }
  }

  handleScroll = (event) => {
    if ((document.body.clientWidth > 789 && window.scrollY > 48)) {
      this.setState({fixed: true});
      document.querySelector("body").classList.add('header-menu-fixed')
    } else {
      this.setState({fixed: false});
      document.querySelector("body").classList.remove('header-menu-fixed')
    }
  };

  toggleMenu = () => {
    if (!this.state.menuStatus) {
      document.querySelector("#header-menu").classList.add('fixed')
    } else {
      if ((document.body.clientWidth > 789 && window.scrollY < 48)) {
        document.querySelector("#header-menu").classList.remove('fixed')
      }
    }
    this.setState({ menuStatus: !this.state.menuStatus })
  }

  render () {
    const { language } = this.context;
    let conteudos = ''
    let loja = ''
    switch (language) {
      case 'pt-br':
        conteudos = 'Conteúdos';
        loja = 'Loja';
        break;
      case 'en-us':
        conteudos = 'Contents';
        loja = 'Shop';
        break;
      case 'es-es':
        conteudos = 'Contenido';
        loja = 'Tienda';
        break;
      default:
    }
    return (
      <Container id="header-menu" className={ this.state.fixed ? 'fixed' : '' }>
        <div className="wrapper flex">
          <Link to="/">
            <Logo />
          </Link>
          <Search />
          <div className="items">
            <Submenu />
            <button onClick={ (e) => { this.toggleMenu() } } className={ `hamburger-menu ${this.state.menuStatus ? 'close' : ''}` }>
              {
                this.state.menuStatus ? 'Fechar' : 'Menu'
              }
              <i></i>
            </button>
            <Link to="/conteudos" className="link">
              { conteudos}
            </Link> 
            {
              language === 'pt-br' && (
                <a href="https://loja.guararapes.com.br/" rel="noopener noreferrer" target="_blank" className="link">
                  { loja }
                </a> 
              )
            }
          </div>
        </div>
        <MenuMobile status={ this.state.menuStatus } />
      </Container>
    )
  }
}

Header.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

Header.contextType = LanguageContext;

export default Header;
